import { render, staticRenderFns } from "./SQuesTwentyNine.vue?vue&type=template&id=08f1b12b&scoped=true&"
import script from "./SQuesTwentyNine.vue?vue&type=script&lang=js&"
export * from "./SQuesTwentyNine.vue?vue&type=script&lang=js&"
import style0 from "./SQuesTwentyNine.vue?vue&type=style&index=0&id=08f1b12b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08f1b12b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib/components/VCard';
installComponents(component, {VCardText})
